import { Link } from "react-router-dom";
import { BRAND } from "@/constants/brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-charcoal text-brand-cream">
      <div className="container-pp px-6 lg:px-10 py-20 grid gap-14 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img src={BRAND.logoUrl} alt="Pop Panda" className="h-12 w-12 object-contain bg-brand-cream rounded-full p-1.5" />
            <div>
              <div className="font-display text-3xl">Pop Panda</div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-brand-cream/60">{BRAND.tagline}</div>
            </div>
          </div>
          <p className="mt-6 text-sm text-brand-cream/70 leading-relaxed max-w-xs">
            Premium popsicles crafted in Karnataka. Innovation-driven, customer-first, building India's most loved popsicle brand.
          </p>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-brand-yellow mb-4">{BRAND.addresses.manufacturing.label}</div>
          <div className="font-display text-2xl mb-2">{BRAND.addresses.manufacturing.line1}</div>
          <address className="not-italic text-sm text-brand-cream/75 leading-relaxed">
            {BRAND.addresses.manufacturing.lines.map((l) => (<div key={l}>{l}</div>))}
          </address>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-brand-yellow mb-4">{BRAND.addresses.retail.label}</div>
          <div className="font-display text-2xl mb-2">{BRAND.addresses.retail.line1}</div>
          <address className="not-italic text-sm text-brand-cream/75 leading-relaxed">
            {BRAND.addresses.retail.lines.map((l) => (<div key={l}>{l}</div>))}
          </address>
          <div className="mt-5 text-sm text-brand-cream/80">
            <div className="text-[10px] uppercase tracking-[0.2em] text-brand-yellow mb-1">WhatsApp</div>
            <a data-testid="footer-whatsapp" href={BRAND.whatsappUrl} target="_blank" rel="noreferrer" className="hover:text-brand-yellow">+91 8867566028</a>
          </div>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-brand-yellow mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-brand-cream/80">
            <li><Link to="/worlds" data-testid="footer-worlds">Pop Panda Worlds</Link></li>
            <li><Link to="/flavour-creator" data-testid="footer-create">Create Your Own Popsicle</Link></li>
            <li><Link to="/flavour-lab" data-testid="footer-lab-public">Flavour Lab</Link></li>
            <li><Link to="/journey" data-testid="footer-journey">Pop Panda Journey</Link></li>
            <li><Link to="/challenges" data-testid="footer-challenges">Innovation Challenges</Link></li>
            <li><Link to="/contributors" data-testid="footer-contributors">Contributors Wall</Link></li>
            <li><Link to="/innovation-lab" data-testid="footer-lab">Innovation Lab</Link></li>
            <li><Link to="/hall-of-fame" data-testid="footer-hof">Hall of Fame</Link></li>
            <li><Link to="/request-stock" data-testid="footer-stock">Request Stock</Link></li>
            <li><Link to="/retailer" data-testid="footer-retailer">Retailer Portal</Link></li>
            <li><Link to="/franchise" data-testid="footer-franchise">Franchise</Link></li>
            <li><Link to="/student-opportunities" data-testid="footer-students">Student Opportunities</Link></li>
            <li><Link to="/event-orders" data-testid="footer-events">Event Orders</Link></li>
            <li><Link to="/bulk-orders" data-testid="footer-bulk">Bulk Orders</Link></li>
            <li><Link to="/careers" data-testid="footer-careers">Careers</Link></li>
            <li><Link to="/journal" data-testid="footer-journal">Journal</Link></li>
            <li><Link to="/feedback" data-testid="footer-feedback">Leave a Review</Link></li>
            <li><Link to="/complaints" data-testid="footer-complaints">Complaints &amp; Feedback</Link></li>
            <li><Link to="/pay" data-testid="footer-pay">Pay an Invoice</Link></li>
            <li><Link to="/contact" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-pp px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-brand-cream/55">
          <div>© {new Date().getFullYear()} The Pop Panda. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <span>Crafted in Karnataka, India</span>
            <Link to="/admin/login" data-testid="footer-admin">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
